import { render, staticRenderFns } from "./AccountPw.vue?vue&type=template&id=b5ea76c6"
import script from "./AccountPw.vue?vue&type=script&lang=js"
export * from "./AccountPw.vue?vue&type=script&lang=js"
import style0 from "./AccountPw.vue?vue&type=style&index=0&id=b5ea76c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports